import { LayoutModule } from '@angular/cdk/layout';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, PLATFORM_ID, TransferState, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { SharedModule } from './common/shared.module';

import { registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AffiliateComponent } from './common/components/affiliate/affiliate.component';
import { CookieComponent } from './common/components/cookie/cookie.component';
import { MainModule } from './main/main.module';
import { ConfigService, initializeApp } from './core/config.service';
import { PopInNotificationsModule } from '@www/common/components/pop-in-notifications/pop-in-notifications.module';
import { UniversalTranslateLoader } from './prerendering/universal-translate-loader';

import localeAr from '@angular/common/locales/ar';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeId from '@angular/common/locales/id';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import localeZh from '@angular/common/locales/zh';

registerLocaleData(localeAr, 'ar');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeId, 'id');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeJa, 'ja');
registerLocaleData(localePl, 'pl');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeZh, 'zh');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient, transferState: TransferState, platformId: Object) => UniversalTranslateLoader(http, transferState, platformId),
        deps: [HttpClient, TransferState, PLATFORM_ID]
      },
    }),
    HttpClientModule,
    LayoutModule,
    MainModule,
    SharedModule,
    RecaptchaV3Module,
    CookieComponent,
    AffiliateComponent,
    PopInNotificationsModule,
  ],
  providers: [
    CookieService,
    ConfigService,
    provideAppInitializer(() => {
      const initializerFn = (initializeApp)(inject(ConfigService));
      return initializerFn();
    }),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (configService: ConfigService) => {
        const config = configService.getConfig();

        return config.RECAPTCHA_KEY;
      },
      deps: [ConfigService],
    },
    provideBrowserGlobalErrorListeners(),
    provideClientHydration(withEventReplay())
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
